<div class="cart-item" >

  <div class="image-not-found">

<!--    <image *ngIf="bookingItem.imageLink; else elseBlock"-->
<!--           [imageLink]="bookingItem.imageLink"></image>-->

    <div *ngIf="imageLink; else noImageFound" class="image-wrapper">
      <image [imageLink]="imageLink"></image>
    </div>

  </div>
  <ng-template #noImageFound>
    <img src="../assets/not_found.png" class="image-not-found"/>
  </ng-template>


  <div class="product-info">
    <div>
      <div class="product-name">{{bookingItem.name}}</div>
      <div class="author">{{bookingItem.author}}</div>
    </div>



    <button class="menu-button-cart" (click)="deleteBookingItem()">
      <span class="icon-trash_">
        <img src="../../../../assets/icons/trash.svg" class="icon-menu">
      </span>
    </button>
  </div>
</div>



